/**
 * Increment when retailer sees Showroom Apparel C1 title banner
 * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40968
 */ export var SHOWROOM_APPAREL_C1_TITLE_BANNER = 'SHOWROOM_APPAREL_C1_TITLE_BANNER';
